<template>
<div v-if="raw_fields" class="modal is-active">
    <div class="modal-background" @click.prevent="close"></div>
    <div class="modal-content">
        <form v-if="!ack_msg" ref="form" class="whitepaper__form" method="post" @submit.prevent="submit">
            <div class="content" ref="content" v-html="raw_fields.content"></div>
            <fieldset :disabled="submitting">
                <div class="field" v-for="field in fields">
                    <component :is="getType(field.type)" :config="field" />
                </div>
                <div class="field actions">
                    <button v-for="action in actions" :class="['button bg-orange is-rounded', {'is-loading': submitting}]">{{action.label}}</button>
                </div>
            </fieldset>
        </form>
        <template v-else>
            <div class="content" v-if="ack_msg" v-html="ack_msg"></div>
            <div class="content" v-if="res_url">
                <p>If the download didn't start automatically or has been blocked, please <a :href="res_url" target="_blank">click here</a>.</p>
            </div>
            <div class="field has-text-right">
                <button @click.prevent="close" class="button bg-orange is-rounded">OK</button>
            </div>
        </template>
    </div>
</div>
</template>

<script>
import * as components from './modules/formfields';
export default {
    name        :   'WhitepaperForm',
    components,
    data()
    {
        return {
            submitting  :   false,
            raw_fields  :   null,
            res_url     :   null,
            ack_msg     :   null
        }
    },
    computed    :   {
        fields()
        {
            if (!this.raw_fields) return null;
            return this.raw_fields.fields.fields;
        },
        actions()
        {
            if (!this.raw_fields) return null;
            return this.raw_fields.fields.actions;
        }
    },
    created()
    {
        this.$bus.$on('onWhitepaperRequired', (fields) => {
            this.raw_fields =   fields;
        });
    },
    beforeDestroy()
    {
        this.raw_fields =   null
        this.$bus.$off('onWhitepaperRequired');
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
    methods     :   {
        getType(type)
        {
            if (type == 'text' || type == 'email') return 'Input';
            if (type == 'radio') return 'Radio';
            if (type == 'countrylist' || type == 'select') return 'DropdownList';
            return type;
        },
        submit(e)
        {
            if (this.submitting) return false;
            this.submitting =   true;
            let data    =   new FormData(this.$refs.form);
            axios.defaults.headers.common['X-CSRF-TOKEN']   =   csrf;
            axios.post(
                base_url + endpoints.whitepaper + this.raw_fields.id,
                data
            ).then(resp => {
                this.submitting =   false;
                this.res_url    =   resp.data.spoil.url;
                this.ack_msg    =   resp.data.message;
                delete axios.defaults.headers.common['X-CSRF-TOKEN'];
                let win =   window.open(base_url.rtrim('/') + resp.data.spoil.url, '_blank');
                win.focus();
            }).catch(error => {
                this.submitting =   false;
                delete axios.defaults.headers.common['X-CSRF-TOKEN'];
                if (error.response && error.response.data && error.response.data.message) {
                    this.$bus.$emit('onShowMessage', error.response.data.message, 'danger', 'ZOHO API FAILURE');
                }
            });
        },
        reset()
        {
            this.submitting =   false;
            this.raw_fields =   null;
            this.res_url    =   null;
            this.ack_msg    =   null;
        },
        close(e)
        {
            this.reset();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/WhitepaperForm.vue